import { render, staticRenderFns } from "./sds-widget.vue?vue&type=template&id=2b561552"
import script from "./sds-widget.vue?vue&type=script&lang=js"
export * from "./sds-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports